<template>
	<v-container grid-list-md px-0>
		<v-layout wrap>
			<v-flex xs6 md2>
				<v-text-field
					label="Minuten"
					type="number"
					v-model="reservation.costData.minutes"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs6 md2>
				<v-text-field
					label="Uren"
					type="number"
					v-model="reservation.costData.hours"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex md1 class="hidden-sm-and-down"> </v-flex>
			<v-flex xs4 md2>
				<v-text-field
					label="Dagen"
					type="number"
					v-model="reservation.costData.days"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs4 md2>
				<v-text-field
					label="Weken"
					type="number"
					v-model="reservation.costData.weeks"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs4 md2>
				<v-text-field
					label="Maanden"
					type="number"
					v-model="reservation.costData.months"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs12 md4>
				<v-layout>
					<v-flex xs6>
						<v-text-field
							label="Afgelegde afstand"
							type="number"
							v-model="reservation.costData.mileage"
							@focus="reservation.setCustomDistance = true"
						></v-text-field>
					</v-flex>
					<v-flex xs6>
						<v-checkbox
							v-model="setCustomDistance"
							:readonly="reservation.wialonUnitId === '0'"
							label="Handmatig"
						></v-checkbox>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs6 md2>
				<v-text-field
					label="Korting"
					type="number"
					v-model="reservation.discount"
					min="0"
					step="0.01"
				></v-text-field>
			</v-flex>
			<v-flex xs6 md3>
				<v-text-field
					label="Km vrij"
					type="number"
					readonly
					v-model="reservation.costData.totalKmFree"
				></v-text-field>
			</v-flex>
			<v-flex xs4 md2 px-0>
				<v-text-field
					label="Extra artikelen"
					type="text"
					readonly
					v-model="additionalItems"
					@click.native="editAdditionalItems.showModal = true"
				></v-text-field>
			</v-flex>
			<v-flex md1 xs3 px-0>
				<v-btn
					v-if="editable"
					flat
					icon
					color="pink"
					@click.native="editAdditionalItems.showModal = true"
				>
					<v-icon>add</v-icon>
				</v-btn>
				<v-btn
					v-if="!editable"
					flat
					icon
					color="pink"
					@click.native="editAdditionalItems.showModal = true"
				>
					<v-icon>pageview</v-icon>
				</v-btn>
			</v-flex>
			<v-flex xs5 md3>
				<v-text-field
					label="Km prijs"
					type="number"
					min="0"
					step="0.01"
					v-model="reservation.kmPrice"
				></v-text-field>
			</v-flex>
			<v-flex xs6 md3 style="display: none">
				<v-text-field
					label="BTW tarief"
					type="number"
					min="0"
					step="0.01"
					v-model="reservation.vat"
				></v-text-field>
			</v-flex>
			<v-flex xs3 md3>
				<v-text-field
					label="Totaalbedrag"
					type="text"
					v-model="reservation.costData.total"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs3 md3>
				<v-text-field
					label="Betaald"
					type="text"
					v-model="reservation.amountPaid"
					readonly
				></v-text-field>
			</v-flex>
			<v-flex xs2 md2>
				<v-btn color="primary" flat @click.native="showPrices()"
					>Toon tarieven</v-btn
				>
			</v-flex>
			<v-flex xs12 v-if="reservation.costData.dayPriceReached">
				<v-alert
					type="info"
					value="true"
					color="grey lighten-3"
					class="black--text"
				>
					Let op: dagtarief wordt gebruikt voor het aantal uren ({{
						reservation.costData.hours
					}}).
				</v-alert>
			</v-flex>
		</v-layout>
		<reservation-prices
			:reservation="reservation"
			:edit="edit"
		></reservation-prices>
		<additional-items
			:reservation="reservation"
			:edit="editAdditionalItems"
			:editable="editable"
		></additional-items>
	</v-container>
</template>
<script>
import ReservationPrices from '@/components/Reservations/ReservationPrices';
import AdditionalItems from '@/components/Reservations/AdditionalItems';

export default {
	name: 'ReservationCostDetails',
	props: ['reservation', 'editable'],
	data() {
		return {
			edit: {
				showModal: false
			},
			editAdditionalItems: {
				showModal: false
			}
		};
	},
	components: { ReservationPrices, AdditionalItems },
	computed: {
		mileageCost() {
			var total =
				parseFloat(this.reservation.kmPrice) *
				(parseFloat(this.reservation.costData.mileage) -
					parseFloat(this.reservation.freeMileage));
			return total >= 0 ? total : 0;
		},
		total() {
			return (
				parseFloat(this.reservation.totalWithoutMileageCost) +
				parseFloat(this.mileageCost)
			).toFixed(2);
		},
		setCustomDistance: {
			get() {
				return this.reservation.setCustomDistance !== '0';
			},
			set(value) {
				this.reservation.setCustomDistance = value;
			}
		},
		totalCustomer() {
			let totalPrice = this.total - parseFloat(this.reservation.discount);
			return totalPrice >= 0 ? totalPrice.toFixed(2) : 0;
		},
		additionalItems() {
			let additionalItems = this.reservation.costData.additionalItems;
			let itemList = '';
			if (additionalItems && additionalItems.length) {
				for (let i = 0; i < additionalItems.length; i++) {
					itemList +=
						' ' +
						additionalItems[i]['description'] +
						(additionalItems.length > 1 ? ', ' : '');
				}

				return additionalItems.length + ' (' + itemList + ')';
			} else {
				return '0';
			}
		}
	},
	methods: {
		showPrices() {
			this.edit.showModal = true;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Reservations/ReservationCostDetails.vue